// extracted by mini-css-extract-plugin
export default {"modal-confirm-ask-why":"ModalConfirmAskWhy_modal-confirm-ask-why__sxByr","modal-confirm-ask-why-image":"ModalConfirmAskWhy_modal-confirm-ask-why-image__nTxwT"};